import moment from 'moment-timezone';
import { dateFormats } from './constants';

const LOCAL_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm';

/**
 * Given a localDate string and optional time in ISO_8601, return a date object
 * @param localDate
 * @param time (optional)
 * @returns {*}
 */
export function localDateToDate(localDate, time = '12:00') {
  return moment(`${localDate}T${time}`, LOCAL_DATE_TIME_FORMAT).toDate();
}


const NULL_DATE_TIME = { date: null, time: null };
/**
 * Given a timestamp and a timezone, return a date and a time
 * @param scheduled
 * @param timezone
 * @returns {*}
 */
export function toDateTime({ scheduled, timezone }) {
  if (typeof scheduled !== 'number' || typeof timezone !== 'string') {
    return NULL_DATE_TIME;
  }

  const scheduledMoment = moment.tz(scheduled, timezone);

  return {
    date: scheduledMoment.format(dateFormats.ISO_8601),
    time: scheduledMoment.format('HH:mm')
  };
}

/**
 * Given a date, military time, and a timezone, get an epoch timestamp
 * @param date
 * @param time
 * @param timezone
 * @returns {*}
 */
export function toTimestamp({ date, time, timezone }) {
  if (typeof date !== 'string' || typeof time !== 'string' || typeof timezone !== 'string') {
    return null;
  }

  return moment.tz(`${date}T${time}`, LOCAL_DATE_TIME_FORMAT, timezone).valueOf();
}

/**
 * Given a timestamp and a fromZone, return a new timestamp that represents the originating LOCAL time in the TO zone
 * @param timestamp original timestamp
 * @param fromZone originating zone of the timestamp
 * @param toZone  zone to shift timestamp to
 * @returns {*} timestamp of fromTime local date time in the toZone
 */
export function shiftTimestamp({ timestamp, fromZone, toZone }) {
  if (typeof timestamp !== 'number' || typeof fromZone !== 'string' || typeof toZone !== 'string') {
    return null;
  }

  if (fromZone === toZone) {
    return timestamp;
  }

  const timestampInDestinationZone = moment(timestamp).tz(toZone).format(LOCAL_DATE_TIME_FORMAT);

  return moment.tz(timestampInDestinationZone, LOCAL_DATE_TIME_FORMAT, fromZone).valueOf();
}

export function getDateOptions(minDate, maxDate) {
  const isValidDate = moment(minDate, dateFormats.ISO_8601).isValid() &&
    moment(maxDate, dateFormats.ISO_8601).isValid();

  if (typeof minDate !== 'string' || typeof maxDate !== 'string' || !isValidDate) {
    return [];
  }

  const minDateMoment = moment(minDate, dateFormats.ISO_8601);
  const maxDateMoment = moment(maxDate, dateFormats.ISO_8601);

  const options = [];

  while (!minDateMoment.isAfter(maxDateMoment)) {
    options.push(minDateMoment.format('YYYY-MM-DD'));
    minDateMoment.add(1, 'day');
  }

  return options;
}


// WEBPACK FOOTER //
// ./src/js/util/DateUtil.js